"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Collection = function (_a) {
    var collectionSlug = _a.collectionSlug, games = _a.games, count = _a.count;
    var t = (0, next_intl_1.useTranslations)('translation');
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var onClickHandler = (0, react_1.useCallback)(function () {
        router.push(generateUrlWithLang("/games/".concat(collectionSlug)));
    }, [generateUrlWithLang, collectionSlug, router]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper, onClick: onClickHandler },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.backgroundMask, " backgroundMask") }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t(collectionSlug)),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.imageContainer }, games === null || games === void 0 ? void 0 : games.map(function (game, idx) { return (react_1.default.createElement("div", { key: "gameImageCollection".concat(idx).concat(game.id) },
                react_1.default.createElement(ui_components_1.Image, { src: (0, apps_shared_1.getGameImageURL)(game.id), alt: "Img of game ".concat(game.title), rootMargin: "400px 0px", layout: "fill" }))); })))));
};
exports.default = Collection;
